import styled from "styled-components";
import { Heading, Logo, Button, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const LandingPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: absolute;
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-color: #000;
    opacity: 0.3;
  }
`;

export const HeadingStyled = styled(Heading)`
  width: 70%;
`;

export const TextStyled = styled(Text)`
  width: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "66%" : "80%")};
`;

export const LandingContainerStyled = styled.article`
  width: 60%;
  height: 100%;
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 0;
  top: 0;
  padding: 4%;
  background: ${props =>
    `linear-gradient(to ${
      props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"
    }, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%);`};
`;

export const ButtonModalStyled = styled(Button)`
  display: block;
  margin-top: ${props => props.theme.spacing.xsmall};
  &:first-of-type {
    margin-top: ${props => props.theme.spacing.small};
  }
  &:last-of-type {
    margin-bottom: ${props => props.theme.spacing.small};
  }
`;

export const LogoStyled = styled(Logo)`
  display: block;
  margin-bottom: ${props => props.theme.spacing.large};
`;

export const SecondaryLogoStyled = styled.img`
  vertical-align: middle;
  & + & {
    margin: 0 15px;
  }
`;
